import Cookies from 'js-cookie'
import {Link, withRouter} from 'react-router-dom'
import {AiFillHome} from 'react-icons/ai'
import {FaSuitcase} from 'react-icons/fa'
import {FiLogOut} from 'react-icons/fi'

import './index.css'

const Header = props => {
  const onClickLogout = () => {
    Cookies.remove('jwt_token')
    const {history} = props
    history.replace('/login')
  }

  return (
    <nav className="header-container">
      <Link to="/">
        <img
          src="https://assets.ccbp.in/frontend/react-js/logo-img.png"
          alt="website logo"
          className="website-header-logo-img"
        />
      </Link>
      <ul className="navbar-items">
        <Link to="/" className="items">
          <li>Home</li>
        </Link>
        <Link to="/jobs" className="items">
          <li>Jobs</li>
        </Link>
      </ul>
      <button type="button" className="logout-button" onClick={onClickLogout}>
        Logout
      </button>
      <div className="nav-icons-container">
        <Link to="/">
          <AiFillHome size="30" color="#ffffff" className="nav-icons" />
        </Link>
        <Link to="/jobs">
          <FaSuitcase size="30" color="#ffffff" className="nav-icons" />
        </Link>

        <FiLogOut
          size="30"
          color="#ffffff"
          className="nav-icons"
          onClick={onClickLogout}
        />
      </div>
    </nav>
  )
}

export default withRouter(Header)
